<template>
  <div id="page-homerequest" class="d-flex">
    <MainBarMenu />
    <!-- <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div> -->
    <div class="layout-content container-fluid ">
      <HeadingUser />
      <div class="page-request py-3">

        <div class="container">
          <p class="title-3 mb-3 ml-3">NUEVA SOLICITUD: PERMISO SINDICAL</p>
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6 col-xl-6 mr-0">
              <template v-if="loading || loadingPage">
                <div id="loader" />
              </template>
              <template v-else>
                <div class="cont-request-text d-flex flex-column justify-content-around mt-0 mt-md-1">
                  <form
                      @submit="SendRequest"
                      onsubmit="return false"
                      class="form-request mt-0 mb-5 mb-md-5 d-flex flex-column flex-md-row align-items-center">
                    <div role="tablist">
                      <b-card no-body class="mb-1 ml-3" style="width: 500px">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                          <b-button class="button1" block v-b-toggle.accordion-1 variant="info">
                            <img class="centerImg2" v-if="validateGeneralData" v-bind:src="require('@/assets/images/icons/circle-check.svg')">
                            <img class="centerImg2" v-else v-bind:src="require('@/assets/images/icons/circle-clock.svg')">
                            Datos generales para la solicitud:
                            <span class="when-opened">
                                <img class="centerImg1" src="@/assets/images/icons/chevron-up.svg">
                              </span>
                            <span class="when-closed">
                                <img class="centerImg1" src="@/assets/images/icons/chevron-down.svg">
                              </span>
                          </b-button>
                        </b-card-header>
                        <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                          <b-card-body class="px-5">
                            <div class="row mt-4">
                              <div class="col-4 mb-md-0">
                                <p class="p1">Business Partner:</p>
                              </div>
                              <div class="col-8 mb-md-2">
                                <v-select
                                    @input="setBp"
                                    :options="bpsNames"
                                    label="name_to_search"
                                    class="style-filter"
                                    required
                                    placeholder="Bucar por: Sharp Id, Cédula o Nombre"
                                >
                                  <template #option="{ name, sharp_id, cc }">
                                    <h3 style="margin: 0">{{ name }}</h3>
                                    <em>Sharp Id: {{ sharp_id }} - CC: {{ cc }}</em>
                                  </template>
                                  <template #no-options>
                                    Lo sentimos, no hay opciones.
                                  </template>
                                </v-select>
                                <!-- <select
                                  v-model="bp"
                                  required
                                  class="custom-select mb-3"
                                  @change="bpInfo"
                                  >
                                  <option value="">--Seleccione Business Partner--</option>
                                  <option v-for="bp in bps.data" v-bind:key="bp.id"
                                    v-bind:value="{id: bp.id, text: bp.name, sharp_id: bp.sharp_id, city: bp.site.city.name, society: bp.society.name,society_id:bp.society_id }">
                                    {{ bp.name }}
                                  </option>
                                </select> -->
                              </div>
                              <div class="col-4 mb-md-0">
                                <p class="p1">Sociedad:</p>
                              </div>
                              <div class="col-8 mb-md-2">
                                <select
                                    v-model="society"
                                    @change="SocietiesInfo"
                                    class="custom-select mb-3">
                                  <option :value="{id:society.id,name:society.name}">{{ society.name }}</option>
                                  <option v-for="society in societies.data" v-bind:key="society.id"
                                          v-bind:value="{id:society.id,name:society.name}">
                                    {{ society.name }}
                                  </option>
                                </select>
                              </div>
                              <!--div class="col-4 mb-md-0">
                                <p class="p1">Site:</p>
                              </div>
                              <div class="col-8 mb-md-5">
                                <select
                                  v-model="site"
                                  required
                                  class="custom-select mb-3"
                                  @change="SocietiesInfo"
                                  >
                                  <option value="">--Seleccione Site--</option>
                                  <option v-for="site in allSites.data" v-bind:key="site.id"
                                    v-bind:value="{id: site.id}">
                                    {{ site.name }}
                                  </option>
                                </select>
                              </div-->
                            </div>
                            <!-- Solicitud de tiquete -->
                            <div class="row pt-4" v-if="canRequestTickets">
                              <div class="col-4">
                                <p class="p1">Solicitud de tiquetes:</p>
                              </div>
                              <div v-if="availabilityTkts === false" class="col-8 text-center">
                                <b-alert show variant="danger">
                                  Tu sindicato ha consumido la totalidad de los tiquetes acordados,
                                  si tienes alguna duda contacta a relaciones laborales.
                                </b-alert>
                              </div>
                              <div v-else class="col-4 custom-control custom-switch">
                                <p class="p1">
                                  No <label class="switch">
                                  <input type="checkbox" v-model="ticket" :disabled="getterSetting.load">
                                  <span class="slider_homeR round"></span>
                                </label> Si
                                </p>
                              </div>
                              <div v-show="this.ticket" class="col-4">
                                <p class="p1">
                                  <b-form-radio v-model="type" name="some-radios" value="Nacional" v-on:change="cleanCity" :disabled="getterSetting.load">
                                    Nacional
                                  </b-form-radio>
                                  <b-form-radio v-model="type" name="some-radios" value="Internacional" v-on:change="cleanCity" :disabled="getterSetting.load">
                                    Internacional
                                  </b-form-radio>
                                </p>
                              </div>
                            </div>
                            <!-- end -->

                            <!-- alerts -->
                            <template v-if="processing_setting" class="pb-5">
                              <b-skeleton animation="throb" width="100%" />
                              <b-skeleton animation="throb" width="55%" />
                              <b-skeleton animation="throb" width="70%" />
                            </template>

                            <template v-else>
                              <toaster-informative
                                  type="warningYellow"
                                  hide-circle-to-icon
                                  :message="messageLimit"
                                  :show="showRequestLimit"
                              />
                              <toaster-informative
                                  type="warning"
                                  hide-circle-to-icon
                                  :message="message_of_toaster"
                                  :show="error_solicited_sindical"
                              />
                              <toaster-informative
                                  hide-circle-to-icon
                                  :message="message_of_toaster"
                                  :show="error_solicited_sindical === false"
                              />
                            </template>


                            <!-- end -->

                            <!-- fecha de la solicitud -->
                            <div class="row">
                              <div class="col-4">
                                <p class="p1">Fecha Permiso:</p>
                              </div>
                              <div class="col-4">
                                <p class="p1">Inicio</p>
                              </div>
                              <div v-show="!unDiaPermiso" class="col-4">
                                <p class="p1">Fin</p>
                              </div>
                              <div v-show="unDiaPermiso && societyHour === true" class="col-4">
                                <p class="p1">Hora inicio:</p>
                              </div>
                            </div>
                            <!-- end -->
                            <div class="row">
                              <div class="col-4 ml-0 mb-md-2">
                                <label>
                                  <p class="p2">
                                    <input id="p-dia"
                                           :disabled="!isEdit"
                                           class="mycheck"
                                           type="checkbox"
                                           v-model="unDiaPermiso"
                                           v-on:change="unDiaPermisoF"
                                    >
                                    Solo un día de permiso
                                  </p>
                                </label>
                              </div>
                              <div class="col-4 mb-md-5">
                                <b-form-datepicker
                                    :disabled="!isEdit"
                                    :min="minDate"
                                    v-model="fechaIni"
                                    class="mb-2"
                                    :date-format-options="{ year: 'numeric' , month: 'numeric', day: 'numeric' }"
                                    placeholder="AAAA-DD-MM"
                                    required
                                    @input="unDiaPermisoF"
                                >
                                </b-form-datepicker>
                              </div>
                              <div v-show="!unDiaPermiso" class="col-4 ml-0 mb-md-5">
                                <b-form-datepicker
                                    :disabled="!isEdit"
                                    :min="fechaIni"
                                    v-model="fechaFin"
                                    class="mb-2"
                                    :date-format-options="{ year: 'numeric' , month: 'numeric', day: 'numeric' }"
                                    placeholder="AAAA-DD-MM">
                                </b-form-datepicker>
                              </div>
                              <div v-show="unDiaPermiso && societyHour === true" class="col-4 ml-0 mb-md-5">
                                <b-form-timepicker
                                    v-model="startHour"
                                    reset-button
                                    class="mb-2"
                                >
                                </b-form-timepicker>
                                <p class="p1">Hora fin:</p>
                                <b-form-timepicker
                                    v-model="endHour"
                                    reset-button
                                    class="mb-2"
                                >
                                </b-form-timepicker>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-4">
                                <p class="p1">Motivo del permiso:</p>
                              </div>
                              <div class="col-8">
                                <input type="text"
                                       :disabled="!isEdit"
                                       v-model="motivoPermiso"
                                       placeholder="Escribe el motivo..."
                                       class="form-control"
                                       required>
                              </div>
                            </div>

                            <!-- Si existe el tiquete -->
                            <div v-if="this.ticket && getterSetting.load === false" class="row pt-4">
                              <div class="col-4">
                                <p class="p1">Horario sugeridos:</p>
                              </div>
                              <div class="col-4">
                                <p class="p1">Ida</p>
                              </div>
                              <div class="col-4">
                                <p class="p1">Vuelta</p>
                              </div>
                            </div>
                            <div v-if="this.ticket && getterSetting.load === false" class="row">
                              <div class="col-4">
                                <p class="mb-md-0"></p>
                              </div>
                              <div class="col-4 mb-md-5">
                                <input type="text"
                                       :disabled="!isEdit"
                                       v-model="horaIda"
                                       placeholder="00:00am - 00:00am"
                                       class="form-control"
                                       required>
                              </div>
                              <div class="col-4 mb-md-5">
                                <input type="text"
                                       :disabled="!isEdit"
                                       v-model="horaRegreso"
                                       placeholder="00:00pm - 00:00pm"
                                       class="form-control"
                                       required>
                              </div>
                            </div>
                            <!-- end -->
                            <!-- <div class="row">
                              <div class="col-12 text-left">
                                <small v-show="diffDate > 0 && diffDate <= this.nationalDays && ticket == true && type == 'Nacional'">
                                  <b-alert show variant="danger">
                                    <li>Estás solicitando un tiquete nacional con menos
                                    de {{this.nationalDays}} días de anticipación, esto puede impactar la aprobación de tu solicitud.</li>
                                    <li v-show="diffDate > 0 && diffDate < 3">Estás solicitando un permiso con menos de 3 días de anticipación, esto puede impactar la aprobación.</li>
                                  </b-alert>
                                </small>
                                <small v-show="diffDate > 0 && diffDate <= this.internationalDays && ticket == true && type == 'Internacional'">
                                  <b-alert show variant="danger">
                                    <li>Estás solicitando un tiquete Internacional con menos
                                    de {{this.internationalDays}} días de anticipación, esto puede impactar la aprobación de tu solicitud.</li>
                                    <li v-show="diffDate > 0 && diffDate < 3">Estás solicitando un permiso con menos de 3 días de anticipación, esto puede impactar la aprobación.</li>
                                  </b-alert>
                                </small>
                                <small v-show="diffDate > 0 && diffDate < 3 && ticket == false">
                                  <b-alert show variant="danger">
                                    <li>Estás solicitando un permiso con menos de 3 días de anticipación, esto puede impactar la aprobación.</li>
                                  </b-alert>
                                </small>
                              </div>
                            </div> -->

                            <!-- only if exist ticket's -->
                            <template>
                              <div v-if="showIfIsNational" class="row pt-0">
                                <template v-if="ticket">
                                  <div class="col-4 mb-md-0 mt-3">
                                    <p class="p1">¿Cual es tu ciudad origen?</p>
                                  </div>
                                  <div class="col-8 mb-md-0 mt-3">
                                    <v-select
                                        :disabled="!isEdit"
                                        class="style-filter"
                                        label="name"
                                        :options="cities.data"
                                        v-model="ciudadActividad" />
                                  </div>
                                </template>
                                <div class="col-4 mb-md-0 mt-3">
                                  <p class="p1">¿Cual es tu ciudad destino?</p>
                                </div>
                                <div class="col-8 mb-md-0 mt-3">
                                  <v-select
                                    :disabled="!isEdit"
                                    class="style-filter"
                                    label="name"
                                    :options="cities.data"
                                    v-model="ciudadDestino" />
                                </div>
                              </div>
                              <div v-if="showIfIsInternational" class="row pt-4">
                                <div class="col-4 mb-md-1 mt-3">
                                  <p class="p1">¿Cual es tu ciudad origen?</p>
                                </div>
                                <div class="col-8 mb-md-0 mt-3">
                                  <v-select
                                      :disabled="!isEdit"
                                      class="style-filter"
                                      label="name"
                                      :options="cities.data"
                                      v-model="ciudadActividad" />
                                </div>
                                <div class="col-4 mb-md-0">
                                  <p class="p1">¿Cual es tu país destino?</p>
                                </div>
                                <div class="col-8 mb-md-0">
                                  <v-select
                                      :disabled="!isEdit"
                                      class="style-filter"
                                      label="name"
                                      :options="countries.data"
                                      v-model="country" />
                                </div>
                                <div class="col-4 mb-md-1 mt-3">
                                  <p class="p1">¿Cual es tu ciudad destino?</p>
                                </div>
                                <div class="col-8 mb-md-0 mt-3">
                                  <input  
                                         :disabled="!isEdit"
                                         type="text"
                                         v-model="ciudadDestinointer"
                                         placeholder="Escribe la ciudad..."
                                         class="form-control"
                                         required>
                                </div>
                              </div>
                            </template>
                            <!-- end -->

                            <!--/b-card-text-->
                          </b-card-body>
                        </b-collapse>

                        <b-card-header header-tag="header" class="p-1" role="tab">
                          <b-button class="button1" block v-b-toggle.accordion-2 variant="info">
                            <img class="centerImg2" v-if="colaboradores.length>0 && approverSel.length == colaboradores.length" v-bind:src="require('@/assets/images/icons/circle-check.svg')">
                            <img class="centerImg2" v-else v-bind:src="require('@/assets/images/icons/circle-clock.svg')">
                            Para quién solicitas el permiso:
                            <span class="when-opened">
                                <img class="centerImg1" src="@/assets/images/icons/chevron-up.svg">
                              </span>
                            <span class="when-closed">
                                <img class="centerImg1" src="@/assets/images/icons/chevron-down.svg">
                              </span>
                          </b-button>
                        </b-card-header>

                        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                          <b-card-body class="px-5">
                            <b-card-text>
                              <toaster-informative
                                  type="warningYellow"
                                  hide-circle-to-icon
                                  :message="messageLimit"
                                  :show="showLimitCollaborators"
                              />
                              <div class="row text-center">
                                <div class="col-4">
                                  <p class="p1">Colaborador</p>
                                </div>
                                <div class="col-2 ml-0 mr-0 p-0 d-flex justify-content-center">
                                  <p class="p1">ID Sharp</p>
                                </div>
                                <div class="col-2 ml-0 mr-0 p-0 d-flex justify-content-center">
                                  <p class="p1">Origen</p>
                                </div>
                                <div class="col-4 ml-0 mr-0 p-0">
                                  <p class="p1">Aprobador</p>
                                </div>
                              </div>
                              <div class="row justify-content-around pl-0" v-for="(input, i) in (colaboradores.length + 1)" :key="i">
                                <div class="col-4 ml-0 mr-0 pl-0 pr-0 mt-2">
                                  <!--span v-if="colaboradores[i] && colaboradores[i] != null"   -->
                                  <v-select
                                      class="style-filter"
                                      label="name_to_search"
                                      :options="workers.data"
                                      v-model="colaboradores[i]"
                                      @input="validateElement"
                                      placeholder="Bucar por: Sharp Id, Cedula ó Nombre"
                                  >
                                    <template #option="{ name, sharp_id, cc }">
                                      <h2 style="margin: 0">{{ name }}</h2>
                                      <em>Sharp Id: {{ sharp_id }} - CC: {{ cc }}</em>
                                    </template>
                                    <template #no-options>
                                      Lo sentimos, no hay opciones.
                                    </template>
                                  </v-select>
                                  <!--/span-->
                                </div>
                                <div class="col-2 pl-0 mt-2 pr-0 center d-flex justify-content-center">
                                  <p class="p2" v-if="colaboradores[i] && colaboradores[i] != null">
                                    {{colaboradores[i].sharp_id}}
                                  </p>
                                </div>
                                <div class="col-2 pl-0 mt-2 pr-0 center d-flex justify-content-center">
                                  <p class="p2" v-if="colaboradores[i] && colaboradores[i] != null">
                                    {{ colaboradores[i].city }}
                                  </p>
                                </div>
                                <div class="col-4 pl-0 mt-2 pr-0 center">
                                    <span class="col-12" v-if="colaboradores[i] && colaboradores[i] != null">
                                      <v-select
                                          :options="workers.approvers"
                                          label="name_to_search"
                                          v-model="approverSel[i]"
                                          class="style-filter"
                                          required
                                          @input="processingerror = true"
                                          placeholder="Bucar por: Sharp Id, Cedula ó Nombre"
                                      >
                                      <template #option="{ name, sharp_id, cc }">
                                        <h2 style="margin: 0">{{ name }}</h2>
                                        <em>Sharp Id: {{ sharp_id }} - CC: {{ cc }}</em>
                                      </template>
                                      <template #no-options>
                                        Lo sentimos, no hay opciones.
                                      </template>
                                      </v-select>
                                      <!-- <span v-if="colaboradores[i] && colaboradores[i] != null">
                                        <v-select
                                        @input="setApprovers(i)"
                                        :options="approversName"
                                        v-model="approversSelect[i]"
                                        class="style-filter"
                                        required
                                      /> -->
                                      <!-- <select
                                        v-model="approverSel[i]"
                                        class="custom-select mb-0"
                                        @change="validateSel"
                                        >
                                        <option v-for="aprobador in workers.approvers"
                                          :key="aprobador.id" :value="aprobador.id">
                                          {{ aprobador.name }}
                                        </option>
                                      </select> -->
                                    </span>
                                </div>
                              </div>
                            </b-card-text>
                          </b-card-body>
                        </b-collapse>

                        <b-card-header header-tag="header" class="p-1" role="tab">
                          <b-button class="button1" block v-b-toggle.accordion-4 variant="info">
                            <img class="centerImg2" v-if="infoAdicional" v-bind:src="require('@/assets/images/icons/circle-check.svg')">
                            <img class="centerImg2" v-else v-bind:src="require('@/assets/images/icons/circle-clock.svg')">
                            Información adicional:
                            <span class="when-opened">
                                <img class="centerImg1" src="@/assets/images/icons/chevron-up.svg">
                              </span>
                            <span class="when-closed">
                                <img class="centerImg1" src="@/assets/images/icons/chevron-down.svg">
                              </span>
                          </b-button>
                        </b-card-header>
                        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                          <b-card-body class="px-5">
                            <b-card-text>
                              <div class="row">
                                <div class="col-12 mb-md-5">
                                  <textarea class="form-control" v-model="infoAdicional" placeholder="Escribe un mensaje adicional para el aprobador..." rows="5"></textarea>
                                </div>
                              </div>
                            </b-card-text>
                          </b-card-body>
                        </b-collapse>

                      </b-card>

                      <div class="row box-error">
                        <div class="col-6 pt-5" align="center">
                          <router-link to="/solicitudes">
                            <button class="btn btn-block btn-white-1">
                              <!--img class="img1" src="@/assets/images/icons/exitWhite.svg" btn-lg btn-outline-dark rounded-pill button3-->
                              &lt;- Volver
                            </button>
                          </router-link>
                        </div>
                        <div class="col-6 pt-5" align="center">
                          <button type="submit"
                                  :disabled="!validaionSendRequest"
                                  class="btn btn-block btn-darkblue-1"
                                  v-if="error_solicited_sindical === false">
                            <img class="logoImg" src="@/assets/images/icons/sendM.svg">
                            Enviar solicitud
                          </button>
                        </div>
                      </div>
                      <div class="row box-error mt-5">
                        <div class="alert-error" v-if="errors_of_servers.is_true">
                          <p>
                            <b class="error_danger">Por favor corrige los siguientes error(s):</b>
                          <ul>
                            <li v-for="(error_of_server, key) in errors_of_servers.data"
                                :key="key">
                              <small v-for="(error, key_error) in error_of_server"
                                     :key="key_error">
                                *  {{ error }}
                              </small>
                            </li>
                          </ul>
                          </p>
                        </div>

                        <div class="col-12 pt-5" align="center">
                          <small v-show="error.flag" class="alert-danger">
                            <b align="center">{{ error.message }}</b>
                          </small>
                          <small v-show="success.flag" class="alert-heading">
                            <b-alert show variant="success">
                              <strong>{{ success.message }}</strong>
                            </b-alert>
                          </small>
                        </div>
                      </div>
                    </div>
                  </form>

                </div>
              </template>
              <div>
                <b-modal
                    ref="my-modal"
                    hide-footer
                    centered
                    no-close-on-backdrop
                    @hidden="hideModal">
                  <div class="modal-permiso" :class="{ 'modal-error': !modalSuccess }">
                    <div class="d-block text-center">
                      <template v-if="modalSuccess">
                        <h3>¡Su solicitud de permiso ha sido enviada exitosamente!</h3>
                        <toaster-informative
                            type="warningYellow"
                            hide-circle-to-icon
                            :message="msjModal"
                            show
                        />
                      </template>
                      <template v-else>
                        <h3>{{this.msjModal}}</h3>
                      </template>
                    </div>
                    <b-button variant="outline-danger"
                              block
                              @click="hideModal">
                      Entendido
                    </b-button>
                  </div>
                </b-modal>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6 col-xl-6 ml-0 mr-0" style="border:1px solid #cecece;">
              <license-template :is-edit="true"
                                :object-edit="licenseTemplateObjectEdit"/>
            </div>
            <!-- .col -->
          </div>
          <!-- .row -->
        </div>
        <!-- .layout-content -->
      </div>
    </div>
  </div>
  <!-- #page-request -->
</template>

<script>
import HeadingUser from "@/components/user/HeadingUser.vue";
import MainBarMenu from "@/components/layouts/MainBarMenu.vue";
import { mapActions, mapState, mapGetters } from "vuex";
import serverConfig from "./../../services/config";
import _ from "lodash";
import {
  NATIONAL,
  INTERNATIONAL
} from '../../common/constants/ticket-types'
import { values } from '@/common/permisos-sindicales/labor-union/term-settings'

export default {
  name: "HomeRequest",
  components: {
    MainBarMenu,
    HeadingUser,
    toasterInformative: () => import("@/components/common/toasters/Informative.vue")
    , licenseTemplate: () => import('../../components/Modules/PermisosSindicales/License/Letters/License/License.vue')
  },
  data: () => ({
    serverPath: serverConfig.permisosURL,
    error: {
      flag: false,
      class: "", //is-valid
      message: "",
    },
    success: {
      flag: false,
      class: "", //is-invalid
      message: "",
    },
    processingerror: false,
    startHour: null,
    endHour: null,
    bp: '',
    msjModal: '',
    flagPath: 0,
    unDiaPermiso: '',
    fechaIni: null,
    fechaFin: '',
    motivoPermiso: '',
    ciudadActividad: '',
    ciudadDestino: '',
    ciudadDestinointer: '',
    ciudadInter: '',
    countryDestino: '',
    country: {//47
      code: 'ALB',
      id: 2,
      name: 'ALBANIA'
    },
    colaboradores: [null],
    colaborador: [],
    approversName:[],
    bpsNames:[],
    bpName:'',
    horaIda: '6am',
    horaRegreso: '6pm',
    ticket: false,
    type: 'Nacional',
    viaticos: false,
    infoAdicional: null,
    trabajadores: [],
    aprobadores: [],
    approverSel: [],
    societyHour: false,
    availabilityTkts: true,
    nationalDays: 4 ,
    internationalDays: 4,
    minDate: new Date(),
    dayBusiness: true,
    //inputs: 1,
    society: {
      id: 0,
      name: ''
    },
    site: '',
    message_of_toaster: '',
    error_solicited_sindical: false
    , errors_of_servers: {
      is_true: false
      , data : []
    }
    , processing_setting: true
    , processing_limit_request: true
    , validation_error: false
    , modalSuccess: false
    , processing_limit_collaborators: false
    , canRequestTickets: true
    , loadingPage: true
  }),
  async beforeMount() {

    // ## validacion si puede solicicar el tiquete dependiendo del sindicato
    if (this.canWithCode('solicitante-sindical')) {
      const laborUnion = this.user.labor_union_admin_name || ''
      const laborUnionLowerCase = 'ticket-'.concat(laborUnion.toLowerCase())
      if (values[laborUnionLowerCase]) {
        const response = values[laborUnionLowerCase]
         if (Array.isArray(response)) this.canRequestTickets = !response.includes('sin tiquetes')
      }
    }


    return this.loadInitialData()
  },
  computed: {
    ...mapState("modCore", ["user", "userData"]),
    ...mapState("modRequest",[
      "bps",
      "workers",
      "loading",
      "availability",
      "societiesHours",
      "settings",
      "cities",
      "countries",
      "states",
      "societies",
      "allSites"
    ])
    , licenseTemplateObjectEdit () {
       return {
         destination_city_name: (this.type === NATIONAL) ? (this.ciudadDestino.name ? `${this.capitalizeText(this.ciudadDestino.name.split(',')[0])} - ${this.capitalizeText(this.ciudadDestino.name.split(',')[1])}` : '') : this.ciudadDestinointer
         , business_partner_society: this.bp.society || null
         , business_partner_name: this.bp.text || null
         , motive: this.motivoPermiso || null
         , additional_information: this.infoAdicional || null
         , collaborators: this.colaboradores || null
         , tickets: this.ticket
         , ticket_type: this.type || ''
         , start_date: this.fechaIni || ''
         , end_date: this.unDiaPermiso ? this.fechaIni : this.fechaFin
         , origin_city_name: this.ciudadActividad.name ? `${this.capitalizeText(this.ciudadActividad.name.split(',')[0])} - ${this.capitalizeText(this.ciudadActividad.name.split(',')[1])}` : null
       }
    }
    , isEdit () {
      return !!(this.formatBusinessDate && !this.processing_setting)
    }
    , validaionSendRequest () {
      return !!(this.validateGeneralData && this.approverSel.length == this.colaboradores.length)
    }
    ,showRequestLimit()
    {
        return !this.processing_limit_request && this.getLimitValidation.available === false && this.canWithCode('solicitante-sindical') && this.ticket
    }
    ,showLimitCollaborators ()
    {
      return !this.processing_limit_collaborators && this.getLimitValidation.available === false && this.canWithCode('solicitante-sindical') && this.ticket
    }
    , messageLimit ()
    {
      let message = ''
      if (
          this.getLimitValidation.can_only_be_managed < this.getLimitValidation.requested_amount
      ) {
        message = '¡Atención! Actualmente no es posible gestionar sus tiquetes aéreos, ya que ha alcanzado el límite establecido en la convención colectiva vigente entre la empresa y la organización sindical. No obstante, aún puede solicitar el permiso correspondiente. Estamos a su disposición para cualquier consulta adicional.'

        if (
            this.getLimitValidation.can_only_be_managed > 0
        ) {
          message = 'Le informamos que solo se podrán gestionar ('
              + this.getLimitValidation.can_only_be_managed
              + ') de sus ('
              + this.getLimitValidation.requested_amount
              + ') tiquetes aéreos debido al límite establecido en la convención colectiva vigente. Para aclarar cualquier duda, le recomendamos consultar con su Business Partner.'
        }
      }
      return message
    }
    , showIfIsNational () {
      return !!(this.type === NATIONAL && !this.getterSetting.load)
    }
    , showIfIsInternational () {
      return (this.type === INTERNATIONAL && !this.getterSetting.load && this.ticket)
    }
    ,fechaFin2: function() {
      return (this.unDiaPermiso) ? this.fechaIni : this.fechaFin;
    },

    ciudadActividad2: function() {
      return (this.type === NATIONAL) ? this.ciudadActividad.name : this.ciudadActividad.name;
    },
    ciudadActividad3: function() {
      return (this.type === NATIONAL) ? this.ciudadDestino.name : this.ciudadDestinointer;
    },

    diffDate: function(){
      let currentDay = new Date();
      let fechaInitial = (this.fechaIni) ? new Date(this.fechaIni) : currentDay;
      var timeDiff = Math.abs(fechaInitial.getTime() - currentDay.getTime());
      return Math.ceil(timeDiff / (1000 * 3600 * 24));
    },
    /****
     * Re-escribiendo las constantes para usarlas en la vista
     ***/
    NATIONAL () {
      return NATIONAL
    },
    INTERNATIONAL () {
      return INTERNATIONAL
    },
    /****
     * Calcular la diferencia de tiempo
     ***/
    get_diff_date () {
      //if (this.unDiaPermiso) {
      return this.get_date_difference(this.get_today,this.fechaIni)
      // }
      //return this.get_date_difference(this.fechaIni, this.fechaFin)
    },
    /****
     * Lista de menssaje corresponsiente a la solicitud del tiquete
     ***/
    list_of_message_to_toaster () {
      return {
        No: {
          message: 'Puedes solicitar permisos desde la fecha ' + (this.formatBusinessDate || '') +
              '. Recuerda que las solicitudes sin tiquetes deben ser solicitadas mínimo con ' + this.getterSetting.value +' días hábiles de ' +
              'anterioridad a la fecha de inicio del permiso sindical, de no ser así no podrás solicitar el permiso.',
          message_warning: 'Estás solicitando un permiso sindical sin tiquetes con menos de '+ this.getterSetting.value +
              ' días hábiles de anterioridad a la fecha de inicio del permiso sindical, tu solicitud no podrá ser gestionada.'
        },
        Nacional: {
          message: 'Puedes solicitar permisos desde la fecha ' + (this.formatBusinessDate|| '') +
              '. Recuerda que las solicitudes con tiquetes nacionales deben ser solicitadas mínimo con ' +
              this.getterSetting.national + ' días hábiles de anterioridad ' +
              'a la fecha de inicio del permiso sindical, de no ser así no podrás solicitar el permiso.',
          message_warning: `Estás solicitando un permiso sindical con tiquetes nacionales con menos de ${this.getterSetting.national} días hábiles de anterioridad de la fecha de inicio del permiso sindical, tu solicitud no podrá ser gestionada`
        },
        Internacional: {
          message: 'Puedes solicitar permisos desde la fecha ' + (this.formatBusinessDate || '') +
              '. Recuerda que las solicitudes ' +
              'con tiquetes internacionales deben ser solicitadas mínimo con ' + this.getterSetting.international +
              ' días hábiles de anterioridad a la fecha inicio del permiso sindical, de no ser así no podrás solicitar el permiso.',
          message_warning: `Estás solicitando un permiso sindical con tiquetes internacionales con menos de ${this.getterSetting.international} días hábiles de anterioridad de la fecha de inicio del permiso sindical, tu solicitud no podrá ser gestionada.`
        },
        warning: {
          message: 'Tu sindicato ha consumido la totalidad de los tiquetes acordados, si tienes alguna duda contacta a relaciones laborales.'
        }
      }
    },
    /**
     * Fomateando fecha
     */
    formatBusinessDate() {
      return this.getBusinessDate.business_date ? this.$moment(this.getBusinessDate.business_date).format('DD-MMM-YYYY') : null
    }
    /*inputs: function(){
      //var cont=0;
      for(let i=0; i<this.colaboradores.length; i++){
        if(this.colaboradores[i] == null){
          const index = this.colaboradores.indexOf(i);
          if (index > -1) {
            this.colaboradores.splice(index, 1);
          }
        }
      }
      return this.colaboradores;
    },*/
    /**
     * Obteniendo las opciones de los tiquetes del Store
     **/
    , validateGeneralData ()
    {
      const valid_initial = !!(this.bp && this.fechaIni && this.fechaFin && this.motivoPermiso && this.horaIda && this.horaRegreso)
      const valid_national = !!(valid_initial && this.ciudadDestino && this.ciudadActividad3 && this.ciudadActividad2)
      const valid_international = !!(valid_initial && this.country.name && this.ciudadDestinointer && this.ciudadActividad)
      return this.ticket ? (this.type === NATIONAL ? (valid_national) : (valid_international) ) : (valid_initial && this.ciudadDestino)
    }
    , ...mapGetters('modSettings', [
      'getterSetting'
    ]),

    ...mapGetters('modRequest', [
      'getBusinessDate'
      , 'getLimitValidation'
    ])
  },
  watch: {
    /***
     * validar cuando la fecha cambie
     ***/
    fechaIni () {
      //   this.valid_tickets()
      this.fechaFin = null
    },

    getBusinessDate() {
      this.valid_tickets()
    },

    fechaFin () {
      // await this.valid_exist_ticket()
      // this.valid_tickets()
    },

    colaboradores: _.debounce(function () {
      this.processingerror = false
    }, 10000),
    processingerror: function (value) {
      if (!value) this.validateNumberOfTickets(this.colaboradores)
    },

    /***
     * esperar que el valor del tique cambie para mostrar el mensaje
     ***/
    async ticket() {
      this.processing_setting = true
      this.country = {}
      this.ciudadDestino = ''
      this.ciudadActividad = ''
      this.ciudadDestinointer = ''

      if (!this.ticket) {
        await this.getSettingOrCustomize()
      } else {
        await this.getSettingOrCustomize(this.type)
        await this.validateNumberOfTickets()
      }

      await this.actGetBusinessDate({ date: this.fechaIni, ticket_type: !this.ticket || this.type })
      this.valid_tickets()
      this.processing_setting = false
    },
    async type () {
      this.processing_setting = true
      await this.actGetBusinessDate({ date: this.fechaIni, ticket_type: !this.ticket || this.type }).finally(() => this.processing_setting = false)
      this.valid_tickets()
    },
  },
  methods:{
    async loadInitialData() {
      try {
        this.valid_exist_ticket()

        const [, holidayResponse] = await Promise.all([
          this.getSettingOrCustomize(),
          this.actCheckHoliday(this.formatDate(new Date()))
        ])

        if (holidayResponse.message === true) {
          this.dayBusiness = false
          this.flagPath = 1
          return this.$router.push({ name: 'errorPage', params: { code: 401 } })
        }

        const [bpResponse] = await Promise.all([
          this.actGetBP(),
          this.actGetSocieties(),
          this.actGetCities(),
          this.actGetStates(),
          this.actGetCountries(),
          this.actGetBusinessDate({ date: this.get_today, ticket_type: this.ticket }),
          this.actGetWorkers({ 0: 0, 1: 0, 2: 0 })
        ])

        this.availabilityTkts = this.availability.tickets
        this.bpsNames = (bpResponse.data || []).map(bp => ({
          id: bp.id,
          name: bp.name,
          sharp_id: bp.sharp_id,
          society_id: bp.society_id,
          site_id: bp.site_id,
          cc: bp.cc,
          site: bp.site,
          society: bp.society,
          name_to_search: `Nombre: ${bp.name} CC: ${bp.cc} SharpId: ${bp.sharp_id}`
        }))
      } catch (error) {
        this.error.flag = true
        this.error.class = 'is-invalid'
        this.error.message = 'No se pudo cargar la información de la solicitud.'
        console.error('Error cargando HomeRequest:', error)
      } finally {
        this.processing_setting = false
        this.loadingPage = false
      }
    },
    ...mapActions("modRequest", [
      "actSaveRequest",
      "actGetBP",
      "actGetWorkers",
      "actGetAvailability",
      "actGetSocietiesInfo",
      "actGetSocieties",
      "actGetSettings",
      "actGetCities",
      "actGetStates",
      "actGetCountries",
      "actCheckHoliday",
      "actGetAllSitesBP",
      "actGetBusinessDate"
      , 'actRequestLimitValidation'
    ]),
    ...mapActions('modSettings', [
      'getSettingOrCustomize'
    ]),


    /****
     * Validacion que exista el tiquete
     ***/
    valid_exist_ticket () {
      if (!this.ticket) {
        this.validate_list_of_message_to_toaster('No')
      } else {
        this.validate_list_of_message_to_toaster(this.type)
      }
      this.minDate = this.getBusinessDate.business_date
    },
    /****
     * Validacion de los  tiquetes nacionales e internaciones y sino aplica
     ***/
    valid_tickets () {
      if (!this.fechaIni) return this.valid_exist_ticket()

      if (this.get_diff_date > -1) {
        if (this.ticket && this.getterSetting.many_key) {
          if (this.type === NATIONAL && !this.getBusinessDate.is_business_date) {
            this.error_solicited_sindical = true
            return this.valid_exist_ticket()
          }
          if (this.type === INTERNATIONAL && !this.getBusinessDate.is_business_date) {
            this.error_solicited_sindical = true
            return this.valid_exist_ticket()
          }
        }
        if (!this.getBusinessDate.is_business_date) {
          this.error_solicited_sindical = true
          return this.valid_exist_ticket()
        }
        this.error_solicited_sindical = false
        return this.valid_exist_ticket()
      }
    },
    /***
     * valida si existe dentro de las opciones de toaster
     ***/
    validate_list_of_message_to_toaster(key = '') {
      if (this.error_solicited_sindical) {
        if (this.list_of_message_to_toaster[key]) {
          return this.set_message_of_toaster(this.list_of_message_to_toaster[key].message_warning)
        }
      }
      if (this.list_of_message_to_toaster[key]) {
        return this.set_message_of_toaster(this.list_of_message_to_toaster[key].message)
      }
    },
    /***
     * asignar el mesaje al toaster informativo
     ***/
    set_message_of_toaster(message = '') { this.message_of_toaster = message },

    async SendRequest() {

      this.validateSel(); // Controla que los aprobadores correspondan a cada colaborador.

      // Elimina null del listado de colaboradores.
      var colaboradoresTmp = this.colaboradores;
      this.colaboradores = colaboradoresTmp.filter(function(x) {
        return x !== null;
      });

      if(this.unDiaPermiso){
        if(!this.startHour){
          this.showModal('Debe seleccionar una hora de inicio.',0);
          return false;
        }
        if(!this.endHour){
          this.showModal('Debe seleccionar una hora de fin.',0);
          return false;
        }
        if(this.endHour < this.endHour){
          this.showModal('La hora fin no puede ser menor a la hora de inicio.',0);
          return false;
        }
      }

      this.fechaFin = this.unDiaPermiso ? this.fechaIni : this.fechaFin

      const horaini = (this.startHour) ? this.startHour.split(':') : null
      const horafin = (this.endHour) ? this.endHour.split(':') : null

      let map = []

      this.colaboradores.forEach((item, index) => {
        map.push({
          sharp_id: item.sharp_id
          , approver_id: this.approverSel[index].id
        })
      })

      const information = [...new Set(map.map(item => item.sharp_id))].map(sharp_id => {
        return {
          sharp_id: sharp_id
          , approver_id: map.find(value => value.sharp_id === sharp_id).approver_id
        }
      })

      const data_ = {
        businessPartner_id: this.bp.id
        , society_id: this.society.id
        , startDate: this.fechaIni
        , endDate: this.unDiaPermiso ? this.fechaIni : this.fechaFin
        , tickets : this.ticket
        , reason: this.motivoPermiso
        , departureTime : this.horaIda
        , returnTime : this.horaRegreso
        , startHour: (horaini) ? horaini[0]+':'+horaini[1] : null
        , endHour: (horafin) ? horafin[0]+':'+horafin[1] : null
        , additionalInfo: this.infoAdicional
        , destination_city_name:  (this.type === NATIONAL) ? this.ciudadDestino.name  : this.ciudadDestinointer
        , destination_country_id: (this.type === NATIONAL) ? '47' : this.country.id
        , type: this.type
        , origin_city_id: this.ciudadActividad.id
        , information
      }
      this.errors_of_servers.is_true = false
      await this.actSaveRequest(data_).then((response) => {
        const {
          detail
          , trace
          , status
          , code
          , message
        } = response
        const traceMessage = trace && trace.message
          ? (Array.isArray(trace.message) ? trace.message.join(' ') : trace.message)
          : ''

        /*
         get errors
        */
        if (
            trace
        ) {
          const { message } = trace

          const errors = {
            421: { 'send_email': message }
            , 406: { 'no_labor_union': message }
          }

          if (
              code && code[0] in errors
          ) {
            this.errors_of_servers.is_true = true
            return this.errors_of_servers.data = errors[code[0]]
          }

          if (
              status in errors
          ) {
            this.errors_of_servers.is_true = true
            return this.errors_of_servers.data = errors[status]
          }
        }

        if (
            detail
        ) {
          this.errors_of_servers.is_true = true
          return this.errors_of_servers.data = detail
        } else if (
            message !== true
        ) {
          this.validation_error = false
          return this.showModal(
            message || traceMessage || 'La solicitud no pudo ser enviada. Intenta nuevamente.',
            0
          )
        } else {
          this.validation_error = false
          return this.showModal('¡Su solicitud de permiso ha sido enviada exitosamente!',1);
        }
      }).catch(() => {
        this.validation_error = false
        this.showModal('No se pudo enviar la solicitud. Verifica la conexión e intenta nuevamente.', 0)
      })
    },

    validateElement(){
      //alert(JSON.stringify(e));
      for(let i=0; i<this.colaboradores.length; i++){
        if(this.colaboradores[i] == null){
          //const index = this.colaboradores.indexOf(i);
          //if (index > -1) {
          this.colaboradores.splice(i, 1);
          //}
        }
      }
    },
    async validateNumberOfTickets(value = []) {
      if(
          this.ticket && this.bp.id && this.canWithCode('solicitante-sindical') && this.fechaIni
      ) {
        const data = {
          society_id: this.society.id
          , startDate: this.fechaIni
          , type: this.type
        }

        if (
            value.length
        ) {
          let collaborators = []

          this.colaboradores.forEach((item) => {
            collaborators.push({ sharp_id: item.sharp_id })
          })

          data.information = [...new Set(collaborators.map(item => item.sharp_id))].map(sharp_id => {
            return {
              sharp_id: sharp_id
            }
          })
          this.processing_limit_collaborators = true
        }

        this.processing_limit_request = true
        await this.actRequestLimitValidation(data).finally(() => {
          this.processing_limit_request = false
          this.processing_limit_collaborators = false
        })
      }
    },
    async unDiaPermisoF(){
      await this.validateNumberOfTickets()
      await this.actGetBusinessDate({ date: this.fechaIni, ticket_type: !this.ticket || this.type })
      this.fechaFin = (this.unDiaPermiso === true) ? this.fechaIni : this.fechaFin;
    },

    loadApprovers(data){
      //alert(JSON.stringify(data[data.length-1].sharp_id));
      this.actApproverSggsted(data[data.length-1].sharp_id).then(() =>{
        this.colaboradores[data.length-1]['approvers'] = this.approvers.data;
      }).catch((response) => {
        this.error.flag = true;
        this.error.class = "is-invalid";
        this.error.message = "No se pudo conectar al servicio: "+response;
      });

    },


    /** Asigna el BP
     * @param id
     * @param name
     * @param sharp_id
     * @param society_id
     * @param site
     * @param society
     */
    setBp({id, name, sharp_id, society_id, site, society }){
      this.bp = {
        id: id,
        text: name,
        sharp_id: sharp_id,
        society_id: society_id,
        city: site.city ? site.city.name : null,
        society: society.name
      }

      this.bpInfo()

      /*this.bps.data.forEach(x => {
        if(x.name === this.bpName){
          this.bp = {
            id: x.id,
            text: x.name,
            sharp_id: x.sharp_id,
            city: x.site.city.name,
            society: x.society.name,
            society_id:x.society_id}
        }
      })*/
      // this.bpInfo()
    },

    async bpInfo(){
      // var data = [];
      this.colaboradores = [null];
      this.approverSel = [];
      this.actGetSocietiesInfo(this.bp.sharp_id).then(() =>{
        this.societyHour = this.societiesHours.message;
      });
      // data[0] = this.user.labor_union_admin_id;
      // data[1] = this.bp.society_id;
      // data[2] = this.bp.id;


      this.society = {
        name:this.bp.society,
        id:this.bp.society_id
      }
    },

    SocietiesInfo(){
      var data = [];
      this.colaboradores = [null];
      this.approverSel = [];

      this.actGetAvailability(this.society.id).then(() =>{
        if(this.availability.licenses === true){
          //this.actGetAllSitesBP(this.bp.id);
          this.actGetSocietiesInfo(this.bp.sharp_id).then(() =>{
            this.societyHour = this.societiesHours.message;
          });
          data[0] = this.user.labor_union_admin_id;
          data[1] = this.society.id;
          data[2] = this.bp.id;

          this.actGetWorkers(data);

          this.bp.society = this.society.name
        }
        else{
          this.flagPath = 0;
          this.$refs['my-modal-society'].show();
        }
      });

    },

    validateSel(){
      this.colaboradores.forEach((worker,i) => {
        if(worker == null){
          this.approverSel[i] = undefined;
        }
      });
    },

    cleanCity(){
      this.ciudadActividad = '';
    },

    formatDate(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;
      return [year, month, day].join('-');
    },
    showModal(msj,flag) {
      this.msjModal = msj;
      this.flagPath = flag;
      this.modalSuccess = flag === 1;
      this.$refs['my-modal'].show()
    },
    hideModal() {
      this.$refs['my-modal'].hide()
      if(this.flagPath === 1){
        this.$router.push({ path: '/solicitudes' });
      }
    },
    hideModalAvailability(){
      this.$router.push({ path: '/solicitudes' });
    },
    hideModalSociety(){
      this.society = [];
      this.$refs['my-modal-society'].hide();
    }
  }
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
.error_danger {
  color: red;
}
.page-request {
  .title-3 {
    font-size: 24px;
    font-weight: bold;
    color: #1C3A4E;
  }
  .cont-request-text {
    .cont-title {
      color: #1c3a4e;
      .title-1 {
        font-size: 40px;
        font-weight: bold;
      }
      .title-2 {
        font-weight: bold;
        font-size: 25px;
        line-height: 27px;

        @media (min-width: 768px) {
          font-size: 80px;
          line-height: 80px;
        }
      }
    }
    .form-request {
      .button1 {
        font-family: "Open Sans";
        background: #E9ECEE;
        color: #1C3A4E;
        font-weight: bold;
        //border-radius: 50px;
        height: 32px;
        font-size: 14px;
        text-align: left !important;
        padding-left: 5%;
        padding-right: 5%;
        outline: none;
        border: none;
        &:hover {
          background: darken(#cddce6, 5);
          border: none;
        }
      }

      .button2 {
        background: #8d9092;
        color: #ffffff;
        border-color: #8d9092;
        font-family: "Poppins";
        border-radius: 100px;
        height: 42px;
        width: 220px;
        font-size: 14px;
        text-align: center !important;
        padding-left: 2%;
        padding-right: 2%;
        &:hover {
          background: darken(#7a7c7e, 5);
        }

        .button3{
          border-radius: 50px;
          font-family: "Open Sans";
          color: #1c3a4e;
          font-size: 20px;
          border: 0 none;
          outline: none;
          text-decoration: none;
          border: 2px solid #1c3a4e;
          /*&:hover {
              text-decoration: none;
              color: #ffffff;
              background: darken(#1c3a4e, 5);
          }*/
        }
      }
    }
  }
  .p1 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #454545;
  }
  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 15px;
    color: #979494;
    text-align: center !important;
  }
  .p3 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #999797;
  }
  .center {
    display: flex;
    align-items: center;
  }

  .button4 {
    background: #99A6AF;
    color: #ffffff;
    border-radius: 8px;
    height: 20px;
    font-size: 8px;
    text-align: left !important;
    padding-left: 5%;
    padding-right: 5%;
    &:hover {
      background: darken(#99A6AF, 5);
    }
  }
  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
    display: none;
  }

  .centerImg2 {
    vertical-align: middle;
    position: relative;
    bottom: 2px;
    padding-right: 2%;
  }

  .centerImg1 {
    width: 16px;
    height: 16px;
    //position: absolute;
    //left: 50%;
    top: 100%;
    //margin-left: -8px;
    //margin-top: 8px;
    float: right;
    //clear: right;
  }
  .mycheck
  {
    /*vertical-align: middle;
    position: relative;
    bottom: 1px;
    border-radius: 20%;*/
    width: 1.3em;
    height: 1.3em;

    border-radius: 30%;
    vertical-align: middle;
    border: 1px solid #ddd;
    // -webkit-appearance: none;
    //outline: none;
    //cursor: pointer;
  }

  .mycheck:checked {
    background-color: #1C3A4E;
  }

  /* The switch - the box around the slider_homeR */
  .switch {
    position: relative;
    display: inline-block;
    width: 45px;
    height: 19px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider_homeR */
  .slider_homeR {
    position: absolute ;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .slider_homeR:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 12px;
    left: 4px;
    bottom: 4px;
    background-color: #242424;
    -webkit-transition: .4s;
    transition: .4s;
  }

  input:checked + .slider_homeR {
    background-color: #779B49;
  }

  input:focus + .slider_homeR {
    box-shadow: 0 0 1px #779B49;
  }

  input:checked + .slider_homeR:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded slider_homeRs */
  .slider_homeR.round {
    border-radius: 34px;
  }

  .slider_homeR.round:before {
    border-radius: 50%;
  }

  .style-filter .vs__search::placeholder,
  .style-filter .vs__dropdown-toggle,
  .style-filter .vs__dropdown-menu {
    background: #dfe5fb;
    border: none;
    color: #394066;
    text-transform: lowercase;
    font-variant: small-caps;
    font-size: 11px;
    line-height: 12px;
  }

  .style-filter .vs__clear,
  .style-filter .vs__open-indicator {
    fill: #394066;
  }

  /* Center the loader */
  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: -75px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  /* Add animation to "page content" */
  .animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s
  }

  @-webkit-keyframes animatebottom {
    from { bottom:-100px; opacity:0 }
    to { bottom:0px; opacity:1 }
  }

  @keyframes animatebottom {
    from{ bottom:-100px; opacity:0 }
    to{ bottom:0; opacity:1 }
  }

  #myDiv {
    display: none;
    text-align: center;
  }
  .box-error {
    max-width: 500px;
    margin: 0 auto ;
    b {
      word-break: break-word;
    }
  }
  .alert-error {
    background: #FFFBE6;
    border-radius: 5px;
    border: 1px solid #E56401;
    width: 100%;
    padding: 12px 4.4rem 12px;
    position: relative;
    &::before {
      content: '';
      display: block;
      background: url("../../assets/images/icons/alert-icon.svg") center/contain no-repeat;
      height: 24px;
      width: 24px;
      position: absolute;
      top: 1rem;
      left: 1rem;
    }
    ul,
    p {
      padding: 0;
      margin: 0;
    }
  }
}
.modal-permiso {
  position: relative;
  &::before {
    content: '';
    display: block;
    background: url("../../assets/images/icons/check-circle.svg") center/contain no-repeat;
    width: 60px;
    height: 60px;
    margin: 0 auto 20px;
    position: relative;
  }
  &.modal-error::before {
    background-image: url("../../assets/images/icons/alert-icon.svg");
  }
  h3 {
    font: normal normal normal 26px/36px "Ubuntu"!important;
    color: #263238;
  }
  button {
    background: #1C3A4E;
    color: #ffffff;
    border: none;
    width: max-content;
    margin: 30px auto 5px;
    padding: 10px 16px;
    border-radius: 6px;
    font: normal normal 700 18px/1 "Ubuntu";
  }
}
</style>
